document.addEventListener("DOMContentLoaded", () => {
  const widget = document.querySelector('#onlinesizing-widget');
  if (!widget) return;

  widget.addEventListener('select', handleSmartfitSelect);
});

function handleSmartfitSelect(event) {
  console.log("Smartfit event:", event.detail);

  // Smartfit sendet meist Größe wie "54" oder "M"
  const sizeValue = event.detail.size || event.detail.code;
  if (!sizeValue) return;

  // Enterprise Theme: Variant option inputs suchen (radio oder select)
  const inputs = document.querySelectorAll(
    'input[type="radio"][name*="Size"], input[type="radio"][name*="Größe"], select[name*="Size"], select[name*="Größe"]'
  );

  let matched = false;

  inputs.forEach(input => {
    if (input.tagName === 'SELECT') {
      for (let option of input.options) {
        if (option.value == sizeValue) {
          input.value = option.value;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          matched = true;
        }
      }
    } else {
      if (input.value == sizeValue) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        matched = true;
      }
    }
  });

  if (!matched) {
    console.warn("❌ Keine passende Größe im Variant Picker gefunden:", sizeValue);
  }
}